// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__7xHl3","ant-page-header-heading-title":"styles_ant-page-header-heading-title__V3gsC","table":"styles_table__1u8Ui"};